export const devices = {
    mobile:{
        portrait: `only screen and (min-width: 300px)`,
        landscape: `only screen and (min-width: 480px)`
    },
    tablet:{
        portrait: `only screen and (min-width: 481px)`,
        landscape: `only screen and (min-width: 769px)`
    }
}